import { required, email,between } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("requiredarray", {
  validate(value) {
    console.log(value);
    return value && value.length > 0;
  },
  message: "this field is required"
});

extend("required", {
  ...required,
  message: "This field is required"
});
extend("between", {
  ...between,
  message: "This field must be between the values of 0 to 100"
});
extend("required-check", {
  validate(value) {
    return value === true;
  },
  message: "This field is required"
});

extend("email", {
  ...email,
  message: "Invalid email"
});

extend("positive", {
  validate(value) {
    return value >= 0;
  },
  message: "the number must be greater than or equal to zero "
});
extend("is_percent", {
  validate(value) {
    return value >= 0;
  },
  message: "the number must be greater than or equal to zero "
});
extend("greater_than_0", {
  validate(value) {
    return !isNaN(parseFloat(value)) && value > 0;
  },
  message: "the number must be greater than zero "
});

extend("odd", value => {
  return value % 2 !== 0;
});

extend("min", {
  validate(value, args) {
    return value.length >= args.length;
  },
  params: ["length"]
});

extend("max", {
  validate(value, args) {
    if(value.length <= args.length){
      return true
    }
    return `The field field may not be greater than ${args.length} characters`;
  },
  params: ["length"],
});

extend("size", {
  validate(value, args) {
    return (
      value
        .toString()
        .replaceAll(" ", "")
        .replaceAll("-", "").length === parseInt(args.length)
    );
  },
  params: ["length"],
  message: "Must have {length} characters"
});

extend("phone", {
  validate(value) {
    return (
      value
        .toString()
        .replaceAll(" ", "")
        .replaceAll("-", "").length === 10
    );
  },
  message: "Must have 10 characters"
});

extend("code", {
  validate(value, args) {
    if (value) {
      return (
        value.toString().replaceAll(" ", "").length === parseInt(args.length)
      );
    } else {
      return false;
    }
  },
  params: ["length"],
  message: "Invalid code"
});

extend("requiredcode", {
  validate(value) {
    return value.toString().replaceAll(" ", "").length > 0;
  },
  message: "code is required"
});
